module.exports = __webpack_public_path__ + "img/button_high_five.512f9da6.svg";